import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Select, Label, FluentProvider, webLightTheme } from '@fluentui/react-components';
import IDropdownOption from '../../../../utils/types/IDropdownOption';
import StatDateFormats from '../../../../utils/types/DateFormats';

const generateDueDateStrings = (
  reportingPeriodEndDate: string,
  filingDueDate: string,
  currentYear: number,
  dayFormat: StatDateFormats,
): {
  reportingPeriodEndDateString: string;
  filingDueDateString: string;
} => {
  const startYear = currentYear;
  let endYear = currentYear;
  const startDateString = `${reportingPeriodEndDate}/${currentYear}`;
  const endDateString = `${filingDueDate}/${currentYear}`;

  if (moment(startDateString).isSameOrAfter(endDateString)) {
    endYear += 1;
  }

  const reportingPeriodEndDateString = moment(
    `${reportingPeriodEndDate}/${startYear.toString()}`,
  ).format(dayFormat);
  const filingDueDateString = moment(`${filingDueDate}/${endYear.toString()}`).format(dayFormat);
  return { reportingPeriodEndDateString, filingDueDateString };
};

const generateReportingDates = (
  reportingPeriodEndDate: string,
  filingDueDate: string,
): IDropdownOption[] => {
  const max = new Date().getFullYear() + 1;
  const min = max - 10;
  const years = Array<IDropdownOption>();
  for (let i = max; i >= min; i -= 1) {
    const { reportingPeriodEndDateString, filingDueDateString } = generateDueDateStrings(
      reportingPeriodEndDate,
      filingDueDate,
      i,
      StatDateFormats.DayBreakout,
    );
    years.push({
      key: i,
      text: `${reportingPeriodEndDateString} - ${filingDueDateString}`,
    });
  }
  return years;
};

interface IInitialReportingPeriodDropdownProps {
  statutoryYearEnd: string;
  auditFilingDueDate: string;
  selectedKey: number;
  handleChange: (
    reportingPeriodEndDate: string,
    filingDueDate: string,
    selectedKey: number,
  ) => void;
  disabled: boolean;
}
const InitialReportingPeriodDropdown = (
  props: IInitialReportingPeriodDropdownProps,
): JSX.Element => {
  const { statutoryYearEnd, auditFilingDueDate, selectedKey, handleChange, disabled } = props;
  const dropdownStyles = { width: 300 };
  const [reportingDates, setReportingDates] = useState<IDropdownOption[]>();
  useEffect(() => {
    setReportingDates(
      statutoryYearEnd && auditFilingDueDate
        ? generateReportingDates(statutoryYearEnd, auditFilingDueDate)
        : [],
    );
  }, [statutoryYearEnd, auditFilingDueDate]);

  return (
    <FluentProvider theme={webLightTheme}>
      <Label id="initialProcessDates">Initial Process Dates</Label>
      <Select
        aria-labelledby="initialProcessDates"
        value={selectedKey ?? ''}
        onChange={(event): void => {
          const yearKey = Number(event.target.value);
          const { reportingPeriodEndDateString, filingDueDateString } = generateDueDateStrings(
            statutoryYearEnd,
            auditFilingDueDate,
            yearKey,
            StatDateFormats.DaySimple,
          );
          handleChange(reportingPeriodEndDateString, filingDueDateString, yearKey);
        }}
        disabled={disabled}
        style={dropdownStyles}
      >
        {reportingDates?.map((option) => (
          <option key={option.key} value={option.key}>
            {option.text}
          </option>
        ))}
      </Select>
    </FluentProvider>
  );
};
export default InitialReportingPeriodDropdown;
